import { useState } from "react";
import { Box, Typography, Collapse } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useSuperAdminPermissions } from "../../../../context/SuperAdmin/PermissionContext";

const CurrentAppsDropdown = () => {
  const [open, setOpen] = useState(false);
  const { permissions } = useSuperAdminPermissions();

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Box
      sx={{
        width: "100%",
        border: "1px solid rgba(51, 107, 135, 0.5)", // Borde con opacidad
        borderRadius: "8px", // Bordes redondeados
        padding: "8px 16px", // Padding general
        transition: "all 0.3s ease", // Suaviza la transición
      }}
    >
      {/* Botón de encabezado */}
      <Box
        onClick={handleToggle}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          width: "100%", // Ancho completo
        }}
      >
        <Typography variant="h6" component="h2" color="#000">
          Apps agregadas{" "}
          <Typography component="span" color={"#73767E"} fontSize={"20px"}>
            ({permissions.length})
          </Typography>
        </Typography>
        <ArrowDropDownIcon
          sx={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)", // Rotar cuando está abierto
            transition: "0.3s",
          }}
        />
      </Box>

      {/* Contenido que se expande dentro del mismo contenedor */}
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box
          sx={{
            marginTop: "8px",
            paddingTop: "8px",
            borderTop: "1px solid rgba(51, 107, 135, 0.5)", // Separador sutil
            maxHeight: "350px", // Máximo de altura
            overflowY: "auto", // Scroll vertical si es necesario
          }}
        >
          {permissions.length > 0 ? (
            permissions.map((permiso, index) => (
              <Typography key={index} color="#000">
                • {permiso.componente}
              </Typography>
            ))
          ) : (
            <Typography
              color="#73767E"
              fontStyle="italic"
              textAlign="center"
            >
              No hay apps agregadas aún
            </Typography>
          )}
        </Box>
      </Collapse>
    </Box>
  );
};

export default CurrentAppsDropdown;
